import React from 'react'
import { useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom';
import avatar from '../assets/images/avatar.jpg';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import styled from 'styled-components'
import AOS from 'aos';
import 'aos/dist/aos.css';


const NavStyled = styled.nav`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    border-right: 1px solid var(--border-color);
    .avatar{
        width: 100%;
        border-bottom: 1px solid var(--border-color);
        text-align: center;
        padding: 1rem 0;
        img{
            width: 70%;
            height: 92%;
            border-radius: 50%;
            /* border: 8px solid var(--border-color); */
            border: 4px solid #288ffd;
        }
    }

    .nav-items{
        width: 100%;
        text-align: center;
        .active-class{
            background-color: var(--primary-color-light);
            color: white;
        }
        li{
            display: block;
            a{
                display: block;
                padding: .45rem 0;
                position: relative;
                z-index: 10;
                text-transform: uppercase;
                transition: all .4s ease-in-out;
                font-weight: 600;
                letter-spacing: 1px;
                &:hover{
                    cursor: pointer;
                    color: var(--white-color);
                }
                &::before{
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 0;
                    height: 50%;
                    background-color: var( --primary-color);
                    transition: All 0.4s cubic-bezier(1,-0.2,.25,.95) ;
                    opacity: 0.21;
                    z-index: -1;
                }
            }

            a:hover::before{
                width: 100%;
                height: 100%;
            }
        }
    }

    footer{
        border-top: 1px solid var(--border-color);
        width: 100%;
        margin-bottom: 1rem;
        p{
            padding: 1.3rem 0;
            font-size: 1.1rem;
            display: block;
            text-align: center;
        }
        .icons{
            display: flex;
            justify-content: center;
            margin-top: 1rem;
            .icon{
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: all .4s ease-in-out;
                cursor: pointer;
                
                &:not(:last-child){
                    margin-right: 1rem;
                }
                svg{
                    margin: .5rem;
                }
            }
            .i-github{
                &:hover{
                    color: #790079;
                }
            }
            .i-linkedIn{
                &:hover{
                    color: #0077b5;
                }
            }
            .i-twitter{
                &:hover{
                    color: #1DA1F2;
                }
            }
            .i-instagram{
                &:hover{
                    color: #bc2a8d;
                }
            }
        }
        .anim{
            text-align:center !important;
            width: 0ch;
            overflow: hidden;
            white-space: nowrap;
            animation: text 8s steps(26) infinite alternate;
            border-right: 3px solid #13265d;
        }
        @keyframes text{
            0%{
                width: 0ch;
            }
            50%{
                width: 18ch;
            }
        }
    }
`;


const Navbar = ({ navToggle, setNavToggle }) => {

    const { pathname } = useLocation()

    const nav = [
        { to: '/', title: 'HOME' },
        { to: '/about', title: 'ABOUT' },
        { to: '/skills', title: 'SKILLS' },
        { to: '/projects', title: 'PROJECTS' },
        { to: '/contact', title: 'CONTACT' },
    ]

    useEffect(() => {
        AOS.init({ duration: 2500, })
    }, [])

    return (
        <NavStyled>
            <div className="avatar">
                <img src={avatar} alt="avatar" />
            </div>

            <ul className="nav-items">
                {nav.map((item, index) => (
                    <li key={index} className="nav-item">
                        <NavLink key={index + 1} to={item.to} className={`${pathname === item.to ? "active-class" : ""}`} onClick={() => setNavToggle(!navToggle)}>{item.title}</NavLink>
                    </li>
                ))}
            </ul>
            <footer className="footer">
                <div className="icons">
                    <a href="https://www.linkedin.com/in/mohdtausif/" target="_blank" rel="noopener noreferrer" className="icon i-linkedIn">
                        <LinkedInIcon />
                    </a>
                    <a href="https://github.com/sheikhtausif" target="_blank" rel="noopener noreferrer" className="icon i-github">
                        <GitHubIcon />
                    </a>
                    <a href="https://twitter.com/executive_error" target="_blank" rel="noopener noreferrer" className="icon i-twitter">
                        <XIcon />
                    </a>
                    <a href="https://instagram.com/executive_error/" target="_blank" rel="noopener noreferrer" className="icon i-instagram">
                        <InstagramIcon />
                    </a>
                </div>
            </footer>
        </NavStyled>
    )
}

export default Navbar